import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { unarchiveClient } from '../api/clients.api';

export const useUnarchiveClient = ({
  clientId,
  onSuccess,
}: {
  clientId: string;
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.clients');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: () => unarchiveClient(clientId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['clients', clientId] });
      displayToastSuccess(t('authenticated.clients:toasts.clientUnarchivedSuccess'));

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.clients:toasts.unarchiveClientError'
      );
    },
  });
};
